import { IRouterController } from "./__types__/UIViewController";
import { IReactionDisposer } from "mobx";
import { UILogicController } from "@view/root/__proto__/withController";
import { IRootTreeModel } from "@models/RootTreeModel";
import { ISidebarViewModel } from "@viewModels/SidebarViewModel/__types__/SidebarViewModel.types";
import { SidebarViewModel } from "@viewModels/SidebarViewModel/SidebarViewModel";
import { AxiosRequestClient } from "@modules/request";
import { IRequestServiceViewModel } from "@viewModels/RequestServiceViewModel/__types__/IRequestServiceViewModel";
import { RequestServiceViewModel } from "@viewModels/RequestServiceViewModel/RequestServiceViewModel";
import { LoginViewModel } from "@viewModels/LoginViewModel/LoginViewModel";
import { ILoginViewModel } from "@viewModels/LoginViewModel/__types__/ILoginViewModel";

class RouterController extends UILogicController implements IRouterController {
  public disposers: { [key: string]: IReactionDisposer } = {};

  public SidebarViewModel: ISidebarViewModel;

  public LoginViewModel: ILoginViewModel;

  public RequestServiceViewModel: IRequestServiceViewModel;

  public constructor(model: IRootTreeModel) {
    super(model);

    this.SidebarViewModel = new SidebarViewModel(this.model);

    this.LoginViewModel = new LoginViewModel(this.model);

    this.RequestServiceViewModel = new RequestServiceViewModel({
      model: this.model,
    });

    AxiosRequestClient.setGlobalInterceptorsListeners({
      handleError: this.RequestServiceViewModel.onResponseError,
      handleRequest: this.RequestServiceViewModel.onRequest,
      handleResponse: this.RequestServiceViewModel.onResponse,
    });
  }

  public get isUserLoggedIn(): boolean {
    return !!this.LoginViewModel.getToken;
  }

  public get isOpenedSideMenu(): boolean {
    return this.SidebarViewModel.isOpenedSideMenu;
  }

  public closeSideMenu = (): void => this.SidebarViewModel.closeSideMenu();

  public openSideMenu = (): void => this.SidebarViewModel.openSideMenu();

  public toggleSideMenu = (): void => this.SidebarViewModel.toggleSideMenu();

  public beforeDestroy = (): void => {
    /** Cancel all disposers */
    Object.values(this.disposers).map((func) => func.call(undefined));

    this.SidebarViewModel.beforeDestroy();
  };
}

export { RouterController };
